import {
  trackCtaClick,
  trackInternalLinkClick,
  trackOutboundLinkClick,
} from './analytics';
import {
  isExternalHref,
  isInternalHref,
  isMailtoOrTelHref,
} from './outboundLink';

const getLinkText = anchor => {
  const explicit =
    anchor.getAttribute('aria-label') || anchor.getAttribute('title');
  if (explicit) return explicit.trim();

  return anchor.textContent?.replace(/\s+/g, ' ').trim().slice(0, 120) || '';
};

const getLinkLocation = anchor =>
  anchor.dataset.analyticsLocation ||
  anchor.closest('[data-analytics-location]')?.dataset.analyticsLocation ||
  undefined;

export const bindLinkClickTracking = () => {
  if (typeof document === 'undefined') return;

  document.addEventListener(
    'click',
    event => {
      const anchor = event.target.closest('a[href]');
      if (!anchor || anchor.dataset.analyticsTrack === 'off') return;

      const href = anchor.getAttribute('href');
      if (!href) return;

      const linkText = getLinkText(anchor);
      const location = getLinkLocation(anchor);
      const extra = location ? { location } : {};

      if (isMailtoOrTelHref(href)) {
        trackCtaClick(href, linkText, extra);
        return;
      }

      if (isExternalHref(href)) {
        trackOutboundLinkClick(href, linkText, extra);
        return;
      }

      if (isInternalHref(href)) {
        trackInternalLinkClick(href, linkText, extra);
      }
    },
    true
  );
};
